<template>
  <q-page padding>
    
    <FirmaClear class=""/>
    
  </q-page>
</template>

<script>
import FirmaClear from '@/components/FirmaClear.vue'
export default {
  components: {
    FirmaClear
  },
  data: () => {
    return {
      alert: false,
    }
  }
}
</script>

<style lang="scss">

</style>